module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0063_design_clean_v002.433d8d07.png";